import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { useClientDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientDetailPresentation } from './presentations';

type Props = {
  id: number;
};

/**
 * クライアント詳細のコンテナコンポーネント
 *
 * - 登録案内カードセクション・人数項目の改称・取引店舗の位置変更は development / staging でのみ反映する。
 *   フラグは Container で読み、Presentation へは表示可否の boolean だけを渡す
 *   （剥がすときの影響範囲を広げないため）
 *
 * @param id - クライアントID（Screen 層でパース・検証済みの数値）
 */
export const ClientDetail: React.FC<Props> = ({ id }) => {
  const {
    state: { data, customFieldDefinitions, partnerFeatureFlags, tooltipId },
    actions: { handleShowTooltip, handleHideTooltip },
  } = useClientDetail(id);

  const { enableStaging } = getEnvFeatureFlag();

  const presentationProps = convertToPresentationProps({
    data,
    customFieldDefinitions,
    partnerFeatureFlags,
  });

  return (
    <ClientDetailPresentation
      clientName={presentationProps.clientName}
      editLink={presentationProps.editLink}
      companyNameKana={presentationProps.companyNameKana}
      representativeName={presentationProps.representativeName}
      corporateNumber={presentationProps.corporateNumber}
      externalClientId={presentationProps.externalClientId}
      groupName={presentationProps.groupName}
      address={presentationProps.address}
      employeeCount={presentationProps.employeeCount}
      partnerBranchName={presentationProps.partnerBranchName}
      customFields={presentationProps.customFields}
      showRevisedHeadcountLabels={enableStaging}
      showRevisedPartnerBranchField={enableStaging}
      showActivationCardSection={enableStaging && presentationProps.showActivationCardSection}
      shippingAddress={presentationProps.shippingAddress}
      contractPlanName={presentationProps.contractPlanName}
      contractPlanLink={presentationProps.contractPlanLink}
      contractStartedOn={presentationProps.contractStartedOn}
      contactPersonName={presentationProps.contactPersonName}
      contactPersonNameKana={presentationProps.contactPersonNameKana}
      contactPersonEmail={presentationProps.contactPersonEmail}
      contactPersonPhone={presentationProps.contactPersonPhone}
      contactPreferredTime={presentationProps.contactPreferredTime}
      applicationNumber={presentationProps.applicationNumber}
      billingContactName={presentationProps.billingContactName}
      billingContactNameKana={presentationProps.billingContactNameKana}
      billingEmail={presentationProps.billingEmail}
      clientFeatureFlags={presentationProps.clientFeatureFlags}
      userCount={presentationProps.userCount}
      nonInvitedUserCount={presentationProps.nonInvitedUserCount}
      createdAt={presentationProps.createdAt}
      updatedAt={presentationProps.updatedAt}
      showTooltip={handleShowTooltip}
      hideTooltip={handleHideTooltip}
      tooltipId={tooltipId}
    />
  );
};
